import { useForm } from "react-hook-form";
import { useState } from "react";
import { Button } from "primereact/button";

import { useSnackbar } from "providers/SnackbarProvider";
import { useConfirmDialogExit } from "hooks";
import {
  SingleStepBody,
  SingleStepDialog,
  SingleStepHeaders,
} from "components/SingleStepDialog";
import {
  buttonAdd,
  buttonAnnul,
  formAddSourceCode,
  labelAddSourceArchive,
  labelAddSourceArchiveSubTitle,
  snackbarResetChat,
  snackbarSummaryResetChatSubTitle,
  snackbarSummarySuccessAddSource,
  snackbarSummarySuccessAddSourceSubTitle,
} from "_constants";
import { addCodesProject, checkLastResetChat } from "services";
import { FormAddSourceArchive } from "components/form/FormAddSourceArchive";
import { useAppDispatch } from "store/store";
import { resetLoadedStatus } from "store/slicer/GestioneDetailProjectSlice";
import { FooterLeftAddSourceArchive } from "./components/FooterLeftAddSourceArchive";
import { setCheckInactiveAnswers } from "store/slicer/GestioneChatSlice";

export const ModalAddSourceArchive = ({
  modalVisibile = false,
  onClose,
  projectId,
}: {
  modalVisibile: boolean;
  onClose: Function;
  projectId: string;
}) => {
  const dispatch = useAppDispatch();
  const [visible, setVisible] = useState(modalVisibile);
  const { showConfirmDialogExit } = useConfirmDialogExit();

  const { handleSubmit, control, setValue, watch } = useForm({
    defaultValues: {
      isArchive: true,
      projectId: projectId,
      sourceIdsList: [],
    },
    shouldFocusError: false,
    mode: "onChange",
  });

  const sourceIdsList = watch("sourceIdsList");
  const { showSnackbar } = useSnackbar();

  const handleDismiss = () => {
    if (control._getDirty()) {
      showConfirmDialogExit({ rejectCallback: resetFormState });
    } else {
      resetFormState();
    }
  };

  const resetFormState = () => {
    control._reset();
    setVisible(false);
    onClose();
  };

  const onSubmit = (formData: any) => {
    if (formData.sourceIdsList.length) {
      addCodesProject(formData)
        .then((_) => {
          checkLastResetChat(projectId).then((res) => {
            if (res.data.canShowWarning) {
              dispatch(setCheckInactiveAnswers(true));
              showSnackbar({
                severity: "warn",
                summary: snackbarResetChat,
                detail: snackbarSummaryResetChatSubTitle,
                life: 5000,
              });
            }
          }).catch((_) => { });
          showSnackbar({
            severity: "success",
            summary: snackbarSummarySuccessAddSource,
            detail: snackbarSummarySuccessAddSourceSubTitle,
            life: 5000,
          });
          dispatch(resetLoadedStatus());
          resetFormState();
        })
        .catch((_) => { });
    }
  };

  return (
    <SingleStepDialog
      onHideCallback={handleDismiss}
      height="648px"
      width="700px"
      header={
        <SingleStepHeaders
          title={labelAddSourceArchive}
          subtitle={labelAddSourceArchiveSubTitle}
        />
      }
      body={
        <SingleStepBody
          content={
            <form
              id={formAddSourceCode}
              onSubmit={handleSubmit(onSubmit)}
              className="width-100"
            >
              <FormAddSourceArchive setValue={setValue} watch={watch} />
            </form>
          }
        />
      }
      footer={
        <div className="flex-container justify-between align-center">
          <div>
            <FooterLeftAddSourceArchive sourceIdsList={sourceIdsList} />
          </div>
          <div>
            <Button
              label={buttonAnnul}
              onClick={handleDismiss}
              text
              severity="secondary"
            />
            <Button
              type="button"
              label={buttonAdd}
              onClick={handleSubmit(onSubmit)}
            />
          </div>
        </div>
      }
      display={visible}
      setVisible={setVisible}
    />
  );
};
